import { InputParameterHierarchyType } from '../../../InputParameterHierarchy/model'
import { EmailTypeKind } from '../../../../models/EmailType'

export type IphContextParam = 'meetingTemplateId' | 'emailTypeId' | 'documentTypeId'

export const IPH_CONTEXT_PARAM: Partial<Record<InputParameterHierarchyType, IphContextParam>> = {
  [InputParameterHierarchyType.AI_FEATURE_PRESET]: 'meetingTemplateId',
  [InputParameterHierarchyType.MEETING_SUMMARY_TEMPLATE]: 'meetingTemplateId',
  [InputParameterHierarchyType.MEETING_PREPARATION_TEMPLATE]: 'meetingTemplateId',
  [InputParameterHierarchyType.MEETING_PREPARATION_EMAIL_TEMPLATE]: 'meetingTemplateId',
  [InputParameterHierarchyType.MEETING_AGENDA_CONFIG]: 'meetingTemplateId',
  [InputParameterHierarchyType.EMAIL_RESPONSE_TEMPLATE]: 'emailTypeId',
  [InputParameterHierarchyType.NEW_EMAIL_TEMPLATE]: 'emailTypeId',
  [InputParameterHierarchyType.DOCUMENT_SUMMARY_TEMPLATE]: 'documentTypeId',
}

export const isIphType = (value: string): value is InputParameterHierarchyType => Object.hasOwn(IPH_CONTEXT_PARAM, value)

export const EMAIL_TYPE_KIND_BY_IPH_TYPE: Record<
  InputParameterHierarchyType.EMAIL_RESPONSE_TEMPLATE | InputParameterHierarchyType.NEW_EMAIL_TEMPLATE,
  EmailTypeKind
> = {
  [InputParameterHierarchyType.EMAIL_RESPONSE_TEMPLATE]: EmailTypeKind.REPLY,
  [InputParameterHierarchyType.NEW_EMAIL_TEMPLATE]: EmailTypeKind.NEW,
}

export const isEmailIphType = (
  value: InputParameterHierarchyType,
): value is InputParameterHierarchyType.EMAIL_RESPONSE_TEMPLATE | InputParameterHierarchyType.NEW_EMAIL_TEMPLATE => IPH_CONTEXT_PARAM[value] === 'emailTypeId'

export const isMeetingTemplateIphType = (value: InputParameterHierarchyType) => IPH_CONTEXT_PARAM[value] === 'meetingTemplateId'

export type ResolvedIphType =
  | { kind: 'email'; iphType: keyof typeof EMAIL_TYPE_KIND_BY_IPH_TYPE }
  | { kind: 'meeting-template' }
  | { kind: 'document' }
  | { kind: 'unknown'; reason: string }

export const resolveIphType = (config: Record<string, unknown>): ResolvedIphType => {
  const iphType = typeof config.iphType === 'string' ? config.iphType : ''
  if (!isIphType(iphType)) {
    return { kind: 'unknown', reason: iphType ? `Unknown IPH type "${iphType}"` : 'Missing IPH type' }
  }
  if (isEmailIphType(iphType)) {
    return { kind: 'email', iphType }
  }
  return isMeetingTemplateIphType(iphType) ? { kind: 'meeting-template' } : { kind: 'document' }
}
